/* eslint-disable */
//@ts-ignore
import React from 'react';
import './styles.scss';
import { useStore } from '../../store/store';
import { useRemoteConfig } from 'core/hooks/use-remote-config';
import { PhotoProgress } from 'src/onboarding/components/ui/photo-progress';

const MainLayoutNew = ({ children }) => {
  const showPhotoProcessing = useStore((state) => state.showPhotoProcessing);
  const { showPhotoProgress } = useRemoteConfig();

  return (
    <div
      className={'layout'}
      style={showPhotoProcessing && showPhotoProgress ? { gap: 30 } : { gap: 80 }}
    >
      {showPhotoProcessing && showPhotoProgress && <PhotoProgress />}

      {children}
    </div>
  );
};

export default MainLayoutNew;
